import { track } from '@/directives/track/send'
import Vue from 'vue'
// import user from '@/api/modules/user'
let count = 0
class ErrorMonitor {
  constructor () {
    this.init()
  }

  init () {
    // 监听 Vue 错误
    Vue.config.errorHandler = this.vueErrorHandler.bind(this)

    // 监听 JS 错误
    window.onerror = this.jsErrorHandler.bind(this)

    // 监听 Promise 错误
    window.addEventListener('unhandledrejection', this.promiseErrorHandler.bind(this))

    // 监听资源加载错误
    window.addEventListener('error', this.resourceErrorHandler.bind(this), true)
  }

  vueErrorHandler (err, vm, info) {
    this.handleError({
      type: 'vue',
      error: err,
      info: info,
      component: vm.$options.name
    })
    throw err
  }

  jsErrorHandler (msg, url, line, column, error) {
    this.handleError({
      type: 'javascript',
      message: msg,
      url: url,
      line: line,
      column: column,
      error: error
    })
    throw error
  }

  promiseErrorHandler (event) {
    debugger

    event.preventDefault() // 阻止默认处理
    this.handleError({
      type: 'promise',
      error: event.reason,
      url: window.location.href
    })
    if (!count) {
      count++
      // user.newLogin2({ phone: 'res.data.mobil' })
    }
  }

  resourceErrorHandler (event) {
    if (event.target && (event.target.src || event.target.href)) {
      this.handleError({
        type: 'resource',
        url: event.target.src || event.target.href,
        html: event.target.outerHTML,
        tagName: event.target.tagName
      })
    }
  }

  handleError (error) {
    // 错误日志格式化
    const errorInfo = {
      ...error,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent
    }

    // 本地保存错误日志
    // this.saveError(errorInfo)

    // 上报错误信息到服务器
    this.reportError(errorInfo)
  }

  saveError (error) {
    // 保存到本地存储
    debugger
    const errortext = this.getErrorContent(error).message + ':_:' + this.getErrorContent(error).detail
    const errors = JSON.parse(localStorage.getItem('errors') || '[]')
    errors.push(errortext)
    console.log(errors, 'errors')
    localStorage.setItem('errors', JSON.stringify(errors))
  }

  /**
   * 上报错误信息到服务器
   * @param {Object} data - 错误数据对象
   * @author huanghan
   * @date 2025/03/10
   */
  reportError (data) {
    try {
      // 上报到服务器

      // 确保data存在且类型正确
      if (!data) {
        console.warn('reportError: 无效的错误数据')
        return
      }
      const clickTrackParam = {
        error_code: data.type || 'unknown',
        error_msg: this.getErrorContent(data).message + ':_:' + this.getErrorContent(data).detail

      }

      // 发送错误跟踪信息 13020471648
      track([{ event_id: 'program_error', event_param: clickTrackParam }])
    } catch (err) {
      // 确保错误上报本身的错误不会影响应用
      console.error('Error in reportError:', err)
    }
  }

  /**
   * 根据错误类型获取错误内容
   * @param {Object} data - 错误数据对象
   * @returns {String} 格式化后的错误内容
   * @private
   */
  getErrorContent (data) {
    // 如果没有数据，返回默认信息
    if (!data) return 'Unknown error'

    // 使用策略模式处理不同类型的错误  data.url || 'Unknown resource URL'
    const errorHandlers = {
      resource: () => this.getResourceErrorContent(data),

      promise: () => this.getPromiseErrorContent(data),

      // 默认处理Vue错误
      default: () => this.getDefaultErrorContent(data),

      // 处理js错误
      javascript: () => this.getJSErrorContent(data),

      vue: () => this.getVueErrorContent(data)
    }

    // 获取对应的错误处理函数，如果没有则使用默认处理
    const handler = errorHandlers[data.type] || errorHandlers.default

    // 执行错误处理函数并返回结果
    return handler()
  }

  /**
  * 处理vue类型的错误内容
  * @param {Object} data - 错误数据对象
  * @returns {data | String} 格式化后的错误内容
  * @private
  */
  getVueErrorContent (data) {
    console.log(data)
    return {
      message: data.error,
      detail: `component:${data.component} error : ${data.info}`
    }
  }

  /**
   * 处理resource类型的错误内容
   * @param {Object} data - 错误数据对象
   * @returns {data | String} 格式化后的错误内容
   * @private
   */
  getResourceErrorContent (data) {
    if (!data.url) return 'Unknown resource URL'
    return {
      message: data.tagName,
      detail: data.html
    }
  }

  /**
   * 处理Promise类型的错误内容
   * @param {Object} data - 错误数据对象
   * @returns {String} 格式化后的错误内容
   * @private
   */
  getPromiseErrorContent (data) {
    // 无错误对象
    if (!data.error) {
      return {
        message: JSON.stringify(data)
      }
    }

    // 有错误消息
    if (data.error.message) {
      return {
        message: data.error.message,
        detail: data.error.stack
      }
    }

    // 有错误数据
    if (data.error.data && data.error.data.error) {
      const path = data.error.data.path || ''
      const errorMsg = data.error.data.error || 'Unknown error'
      return {
        message: errorMsg,
        detail: path
      }
    }

    // 其他情况
    return {
      message: JSON.stringify(data.error)
    }
  }

  /**
   * 处理默认类型的错误内容（Vue错误和JS错误）
   * @param {Object} data - 错误数据对象
   * @returns {String} 格式化后的错误内容
   * @private
   */
  getDefaultErrorContent (data) {
    return data.error
      ? (data.error.message || JSON.stringify(data.error))
      : JSON.stringify(data)
  }

  /**
   * 处理默认类型的错误内容（Vue错误和JS错误）
   * @param {Object} data - 错误数据对象
   * @returns {String} 格式化后的错误内容
   * @private
   */
  getJSErrorContent (data) {
    return {
      message: data.message,
      detail: data.url
    }
  }
}

export default new ErrorMonitor()
